import React from "react";

export function Brand() {
  return (
    <div className="brand">
      <img className="evlogo" src="/brand/logo.png" alt="Energy Vault Group" />
    </div>
  );
}
